// News.js
import React, { useState } from 'react';
import './News.css';

const News = () => {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const newsArticles = [
    {
      id: 1,
      title: 'New Technology Breakthrough Announced',
      date: 'May 15, 2023',
      summary:
        'Researchers have developed a revolutionary new technology that could change how we interact with digital devices.',
      fullContent:
        'The new technology, developed by a team at MIT, uses advanced neural networks to predict user behavior with 95% accuracy. This could lead to more intuitive interfaces that anticipate user needs before they even click. The system is expected to be integrated into consumer devices within the next two years, potentially revolutionizing how we interact with smartphones, computers, and even home appliances.',
      image:
        'https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8dGVjaG5vbG9neXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60',
      category: 'Technology',
    },
    {
      id: 2,
      title: 'Global Summit on Climate Change Concludes',
      date: 'May 12, 2023',
      summary:
        'World leaders have agreed on new measures to combat climate change during the annual global summit held in Geneva.',
      fullContent:
        'The 2023 Global Climate Summit resulted in historic agreements, including a commitment from 195 nations to reduce carbon emissions by 50% by 2030. Key measures include increased funding for renewable energy projects, stricter regulations on industrial emissions, and a global reforestation initiative. Environmental activists have praised the agreements but emphasize the need for swift implementation to meet critical climate targets.',
      image:
        'https://images.unsplash.com/photo-1466611653911-95081537e5b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Y2xpbWF0ZSUyMGNoYW5nZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=500&q=60',
      category: 'Environment',
    },
  ];

  const handleArticleClick = (article) => {
    setSelectedArticle(article);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="news-container">
      {/* Gradient Header */}
      <div className="news-header">
        <h1 className="news-heading">Latest News</h1>
      </div>

      {/* News grid */}
      <div className="news-grid">
        {newsArticles.map((article) => (
          <div
            key={article.id}
            className="news-card"
            onClick={() => handleArticleClick(article)}
          >
            <div className="news-image-container">
              <img
                src={article.image}
                alt={article.title}
                className="news-image"
              />
              <span className="news-category">{article.category}</span>
            </div>
            <div className="news-content">
              <h3 className="news-title">{article.title}</h3>
              <p className="news-date">{article.date}</p>
              <p className="news-summary">{article.summary}</p>
              <button
                className="news-read-more"
                onClick={(e) => {
                  e.stopPropagation();
                  handleArticleClick(article);
                }}
              >
                Read More
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && selectedArticle && (
        <div className="news-modal-overlay" onClick={closeModal}>
          <div className="news-modal" onClick={(e) => e.stopPropagation()}>
            <button className="news-modal-close" onClick={closeModal}>
              &times;
            </button>
            <div className="news-modal-image-container">
              <img
                src={selectedArticle.image}
                alt={selectedArticle.title}
                className="news-modal-image"
              />
              <span className="news-modal-category">
                {selectedArticle.category}
              </span>
            </div>
            <div className="news-modal-content">
              <h2 className="news-modal-title">{selectedArticle.title}</h2>
              <p className="news-modal-date">{selectedArticle.date}</p>
              <div className="news-modal-full-content">
                {selectedArticle.fullContent}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default News;
